import React, { useState } from 'react';
import axios from '../api/axiosInstance'; // ✅ axios avec token auto
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Alert
} from '@mui/material';
import '../css/AddCompany.css';

const AddCompany = () => {
  const [formData, setFormData] = useState({
    siret: '',
    nom: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!/^\d{14}$/.test(formData.siret)) {
      setError('Le SIRET doit contenir exactement 14 chiffres.');
      return;
    }

    try {
      await axios.post('/societes', formData);
      setSuccess("Entreprise ajoutée avec succès.");
      setError('');
      setTimeout(() => navigate('/manage-companies'), 2000);
    } catch (err) {
      setError("Erreur lors de l'ajout de l'entreprise.");
      setSuccess('');
    }
  };

  return (
    <Box className="add-company-container">
      <Sidebar />
      <Box className="main-content">
        <Paper className="add-company-paper" elevation={3}>
          <Typography variant="h5" gutterBottom>Ajouter une entreprise</Typography>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

          <form onSubmit={handleSubmit}>
            <TextField
              label="SIRET (14 chiffres)"
              name="siret"
              value={formData.siret}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Nom de l'entreprise"
              name="nom"
              value={formData.nom}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <Button
              type="submit"
              variant="contained"
              className="add-company-btn"
            >
              Ajouter l'entreprise
            </Button>
          </form>
        </Paper>
      </Box>
    </Box>
  );
};

export default AddCompany;
